export enum TerritorialCitizenAccompanimentEnum {
	INDIVIDUAL_ATTENDANCE = 1,
	DENTAL_ATTENDANCE = 2,
	ATTENDANCE_PROCEDURE = 3,
	VACCINATION = 4,
	GROUP_ACTIVITY = 5,
	FOOD_COMSUMPTION_MARKER = 6,
	HOME_VISIT = 7,
}
